import React, { useEffect, useState } from "react";
import "./progressBody.scss";
import { connect } from "react-redux";
import {
  getQuestionList,
  updateQuestionAnswer,
  updateUserData,
} from "../../../redux/action/user";
import QuestionList from "../questionList";
import { useNavigate } from "react-router";
import ButtonInput from "../../../atoms/button";
import { Container } from "@mui/material";
import SnackBar from "../../../atoms/snackBar";
import CenterLoading from "../../core/CenterLoading";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxSizing: "border-box",
  width: "400px",
  maxWidth: "calc(100vw - 32px)",
  bgcolor: "#fff",
  border: "2px solid #000",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
};

let datagetFirstTime = true;
let timeInvervel;
const ProgressBody = (props) => {
  const navigate = useNavigate();
  const [enableButton, setEnableButton] = useState(false);
  const [isSkipedButtonEnable, setIsSkipedButtonEnable] = useState(false);
  const [open, setOpen] = useState(false);
  const [getDatafirst, setGetDataFirst] = useState(true);

  const [showCongFleg, setShowCongfleg] = useState(-1);
  const [questionList, setQuestionList] = useState([]);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [questionIndex, setQuestionIndex] = useState(1);

  useEffect(() => {
    if (props.user?.questionError) {
      setErrorMessage(props.user?.questionError);
    }
  }, [props.user?.questionError]);

  useEffect(() => {
    if (errorMessage) {
      setOpenSnackBar(true);
    }
  }, [errorMessage]);

  const handleCloseSnackBar = () => {
    setOpenSnackBar(false);
    setErrorMessage("");
  };

  useEffect(() => {
    progressChange();

    // Scroll logic
    const currentElement = document.getElementById(`questionIndex${questionIndex - 1}`);
    if (currentElement) {
      currentElement.scrollIntoView({
        behavior: getDatafirst ? "auto" : "smooth",
        block: "start"
      });
      setGetDataFirst(false);
    }

    // Stop if at the very end
    if (questionIndex === questionList.length) return;

    const currentQuestion = questionList.find(
      (obj) => obj.DisplayOrder === questionIndex
    );
    if (!currentQuestion) return;

    // Update skip button
    changeSkipedButtton(
      currentQuestion.isMandatory === "1" || currentQuestion.isMandatory === ""
        ? false
        : true
    );

    // Logic to trigger "Congrats" AFTER last question of current group is submitted
    const prevQuestion = questionList.find(
      (q) => q.DisplayOrder === questionIndex - 1
    );

    if (!prevQuestion) return;

    const prevDeterminant = prevQuestion.Determinant;
    const prevGroupQuestions = questionList.filter(q => q.Determinant === prevDeterminant);
    const maxPrevDisplayOrder = Math.max(...prevGroupQuestions.map(q => q.DisplayOrder));

    if (prevQuestion.DisplayOrder === maxPrevDisplayOrder) {
      // ✅ User just submitted the last question of the group
      setShowCongfleg(prevQuestion.DisplayOrder);

      if (timeInvervel) {
        clearInterval(timeInvervel);
      }

      timeInvervel = setInterval(() => {
        setShowCongfleg(-1);
      }, 15000);

      props.updateUserData({
        activeGroup: prevDeterminant
      });
    }
  }, [questionIndex, props.user.isLoading, props.user?.questionList]);


  useEffect(() => {
    if (showCongFleg !== -1) {
      if (document.getElementById(`questionIndex${showCongFleg}`)) {
        document.getElementById(`questionIndex${showCongFleg}`).scrollIntoView({
          behavior: "smooth",
          bottom: "500px",
        });
      }
    }
  }, [showCongFleg]);

  const valueChange = (tempQuestionIndex, value, displayOrder) => {
    let tempArray = [...questionList];
    tempArray.map((mainObj) => {
      if (mainObj.userQuestionID === tempQuestionIndex) {
        if (mainObj.Response[0] === "") {
          setQuestionIndex(
            questionIndex + 1 < tempArray.length
              ? questionIndex + 1
              : tempArray.length
          );
          if (props.user.activeGroup !== mainObj.Determinant) {
            props.updateUserData({
              activeGroup: mainObj.Determinant,
            });
          }
        }

        let tempResponse = mainObj.Response.filter((obj) => obj !== "");
        if (mainObj.QuestionType === "Single") {
          tempResponse = [value];
        } else if (mainObj.QuestionType === "Multi") {
          tempResponse = value;
        } else {
          tempResponse = [value];
        }

        mainObj.Response = tempResponse;
        props.updateQuestionAnswer({
          questionId: mainObj.userQuestionID,
          userId: localStorage.getItem("userKey"),
          value: tempResponse,
          surveyId: localStorage.getItem("assesmentKey"),
        });
      }
      return "";
    });

    let isEnableButton = true;
    tempArray.map((obj) => {
      if (obj.Response[0] === "" && obj.isMandatory === "1") {
        isEnableButton = false;
      }
      return "";
    });
    setEnableButton(isEnableButton);

    setQuestionList(tempArray);
  };

  const progressChange = () => {
    const tempDetermin = props.user.totalDetermine.map((obj) => {
      const mandatoryQuestions = props.user.questionList.filter(
        (q) => q.Determinant === obj.name && q.isMandatory === "1"
      );

      const allAnswered = mandatoryQuestions.every(
        (q) => q.Response && q.Response.length > 0 && q.Response[0] !== ""
      );

      return {
        ...obj,
        isFillUp: allAnswered,
      };
    });

    props.updateUserData({
      totalDetermine: tempDetermin,
    });
  };


  useEffect(() => {
    props.getQuestionList();

    // if (!props.user._id && !props.user.surveyId) {
    //   navigate("/");
    // }

    if (
      localStorage.getItem("progressDone") != null &&
      localStorage.getItem("detailDone") != null
    ) {
      navigate(`/result`);
    }
  }, []);

  useEffect(() => {
    if (props.user?.questionList && props.user?.questionList?.length > 0) {
      setQuestionList(props.user?.questionList);

      if (props.user?.questionList.length > 0) {
        props.updateUserData({
          activeGroup: props.user?.questionList[0]?.determinantname,
        });
      }

      let isEnableButton = true;
      props.user?.questionList.map((obj) => {
        if (obj.Response[0] === "" && obj.isMandatory === "1") {
          isEnableButton = false;
        }
        return "";
      });
      setEnableButton(isEnableButton);

      if (datagetFirstTime) {
        let questionIndex = 1;
        let notAnswerd = true;

        const isMandatory = props.user?.questionList[0].isMandatory;
        changeSkipedButtton(
          isMandatory === "1" || isMandatory === "" ? false : true
        );
        props.user?.questionList.map((obj) => {
          if (notAnswerd) {
            if (obj.Response[0] !== "") {
              questionIndex = obj.DisplayOrder + 1;
              if (props.user.activeGroup !== obj.Determinant) {
                props.updateUserData({
                  activeGroup: obj.Determinant,
                });
              }
            }
            if (obj.Response[0] === "") {
              notAnswerd = false;
              if (props.user.activeGroup !== obj.Determinant) {
                props.updateUserData({
                  activeGroup: obj.Determinant,
                });
              }
            }
          }
          return "";
        });
        setQuestionIndex(
          questionIndex < props.user?.questionList.length
            ? questionIndex
            : props.user?.questionList.length
        );
      }
    }
  }, [props.user.questionList]);

  const gotonextquestion = () => {
    setQuestionIndex(
      questionIndex < props.user?.questionList.length
        ? questionIndex
        : props.user?.questionList.length
    );
  };

  const onSubmitQuestion = () => {
    const review = localStorage.getItem("review");

    if (review && review !== "null" && review !== "") {
      localStorage.setItem("progressDone", "true");
      localStorage.setItem("detailDone", "true");
      navigate("/result");
    } else {
      localStorage.setItem("progressDone", "true");
      navigate("/profiledetail");
    }
    setOpen((prev) => !prev);
  };


  const modalSubmit = () => {
    localStorage.setItem("progressDone", true);
    navigate("/profiledetail");
  };

  const changeSkipedButtton = (value) => {
    setIsSkipedButtonEnable(value);
  };


  return (
    <>
      {props.user.isLoading ? (
        <CenterLoading open={props.user.isLoading} />
      ) : (
        <Container className="progrss-body">
          <div className="progrss-body__fixed">
            <QuestionList
              questionList={questionList}
              questionIndex={questionIndex}
              showCongFleg={showCongFleg}
              valueChange={valueChange}
              enableButton={enableButton}
            />
          </div>
        </Container>
      )}
      <div className="progress-footer">
        <Container>
          <div className="progress-footer__fix-footer">
            <div>
              {isSkipedButtonEnable && (
                <ButtonInput
                  class={`progress-footer__button${isSkipedButtonEnable ? "--active" : "--deactive"
                    }`}
                  text={props.user.language?.questionList?.skipButton}
                  disabled={!isSkipedButtonEnable}
                  onSubmit={() => gotonextquestion()}
                />
              )}
            </div>
            <div>
              <ButtonInput
                class={`progress-footer__button${enableButton ? "--active" : "--deactive"
                  }`}
                text={localStorage.getItem("review") ? "Back" : props.user.language?.questionList?.revealButton}
                disabled={!enableButton}
                onSubmit={() => onSubmitQuestion()}
              />
            </div>
          </div>
        </Container>
      </div>
      <SnackBar
        open={openSnackBar}
        message={errorMessage}
        handleCloseSnackBar={handleCloseSnackBar}
      />
    </>
  );
};

ProgressBody.propTypes = {};
ProgressBody.defaultProps = {};

const actionCreators = {
  getQuestionList,
  updateUserData,
  updateQuestionAnswer,
};

export default connect(
  ({ user }) => ({
    user,
  }),
  actionCreators
)(ProgressBody);
